/* import __COLOCATED_TEMPLATE__ from './topic-row.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const TopicRow = dt7948.c(class TopicRow extends SelectKitRowComponent {}, [classNames("topic-row")]);
export default TopicRow;